import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IGenericSelectDto } from '../../models/Interfaces';

@Component({
    selector: 'app-generic-select',
    templateUrl: './generic-select.component.html',
    styleUrls: ['./generic-select.component.scss']
})
export class GenericSelectComponent<T> implements OnChanges {
    
    @Input() showSearchIcon: boolean = true;   // true = lupa, false = caret
    @Input() placeholder: string = 'Buscar...';
    @Input() label: string = 'Seleccionar';
    @Input() items: IGenericSelectDto<T>[] = [];
    @Input() searchOnType = true;
    @Output() selectionChange = new EventEmitter<IGenericSelectDto<T>>();
    @Output() loadMore = new EventEmitter<void>();
    @Output() searchChange = new EventEmitter<string>();
    @Output() cleared = new EventEmitter<void>();
    @Output() enterSearch = new EventEmitter<string>();
    @Input() serverSideSearch = false; 
    currentSearchTerm = '';
    private lastScrollTop = 0;
    private isLoadingMore = false;

    @ViewChild('dropdownRef') dropdownRef!: ElementRef;

    filteredItems: IGenericSelectDto<T>[] = [];
    searchTerm = '';
    showDropdown = false;

    ngOnInit() {
        this.filteredItems = this.items;
    }

    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
        if (this.showDropdown) {
            this.filteredItems = this.items;
            this.searchTerm = '';
        }
    }

    filterItems() {
        const term = (this.searchTerm ?? '').toLowerCase();

        if (this.searchOnType) {
            if (this.currentSearchTerm !== term) {
                this.currentSearchTerm = term;
                this.searchChange.emit(term);
            }
        }
        if (this.serverSideSearch) {
         return; 
    }

        if (!term) {
            this.filteredItems = this.items;
            this.selectionChange.emit({ key: '', value: '' } as IGenericSelectDto<T>);
            this.cleared.emit();
        } else {
            this.filteredItems = this.items.filter(item =>
                item.key.toLowerCase().includes(term)
            );
        }
    }

    selectItem(item: IGenericSelectDto<T>) {
        this.selectionChange.emit(item);
        this.searchTerm = item.key;
        this.showDropdown = false;
    }

    @HostListener('document:click', ['$event.target'])
    onClickOutside(target: HTMLElement) {
        if (this.dropdownRef && !this.dropdownRef.nativeElement.contains(target)) {
            this.showDropdown = false;
        }
    }

    openDropdown() {
        this.showDropdown = true;
        this.filteredItems = this.items;
    }

    onScroll(event: Event): void {
        const target = event.target as HTMLElement;
        const currentScrollTop = target.scrollTop;
        const isScrollingDown = currentScrollTop > this.lastScrollTop;
        const atBottom = currentScrollTop + target.clientHeight >= target.scrollHeight - 1;

        if (isScrollingDown && atBottom && !this.isLoadingMore) {
            this.isLoadingMore = true;
            this.loadMore.emit();

            setTimeout(() => {
                this.isLoadingMore = false;
            }, 400);
        }

        this.lastScrollTop = currentScrollTop;
    }

    onEnter() {
        const query = (this.searchTerm ?? '').trim();
        if (!query) {
            this.cleared.emit();
            return;
        }
        this.enterSearch.emit(query);
        this.showDropdown = true;        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.filteredItems = this.items; 
        }
    }
}
